<template>
  <div class="modal fade update-goal-modal" id="UpdateExpenseModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Editar Despesa</h1>
                  <button type="button" class="btn-close update-goal-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formUpdateGoal" v-on:submit="updateExpenseMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para atualizar</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="month_expense_update" class="form-label fw-medium"
                      >Despesa</label
                    > 
                    <input
                      :value="getCurrentExpense.expense"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="month_expense_update"
                      placeholder="Digite o nome da despesa"
                      autocomplete="off"
                      disabled
                    />
                  </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                  <label for="expense_value_update" class="form-label fw-medium"
                    >Valor</label
                  >
                  <input
                    type="text"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="expense_value_update"
                    autocomplete="off"
                    v-model="expense_value"
                    @input="maskMoney"
                    placeholder="Exemplo: 1.150,00"
                    required
                  />
                </div>

                  <div class="col-12">
                    <div id="alertResponseApiUpdateExpense" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageUpdateExpense">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger update-goal-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonUpdateExpense" class="btn btn-success">Atualizar despesa</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapGetters } from 'vuex';

export default {
  name: "UpdateExpenseModal",
  data () {
    return {
      expense_value: null
    }
  },
  computed: {
    ...mapGetters([
      "getRolesList",
      "getCurrentExpense",
      "getOperations"
    ]),
  },
  watch: {
    'getCurrentExpense.value'(newValue) {
      this.$nextTick(() => {
        if(newValue){
          this.expense_value = newValue;
        }
      });
    }
  },
  methods: {
    maskMoney(e) {
      let value = e.target.value;

      value = value.replace(/\D/g, "");

      if (!value) {
        this.expense_value = "";
        return;
      }

      value = (parseInt(value, 10) / 100).toFixed(2);

      value = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      this.expense_value = value;
    },
    updateExpenseMethod(){
      event.preventDefault();
      const alertResponse = this.alertResponse;

      const expense_id = this.getCurrentExpense.id;
      const expense_value_update = document.getElementById("expense_value_update").value;
      if(!expense_value_update){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      const objUserUpdate = {
        "id": expense_id,
        "value": expense_value_update
      }

      const buttonUpdateExpense = this.$refs.buttonUpdateExpense;
      buttonUpdateExpense.disabled = true;
      buttonUpdateExpense.innerHTML = "Atualizando...";
      

      api.axios.post("/api/financial/expense/update", objUserUpdate).catch(function(error){
        if(error.response.data != undefined){
          buttonUpdateExpense.innerHTML = "Atualizar despesa";
        }
        console.log("error", error);
        alertResponse(error.response.data.message, true);
      }).then(function(response){
        
        if(response != undefined && (response.status == 200 || response.status == 201)){
          buttonUpdateExpense.innerHTML = "Informações atualizadas com sucesso !";
          window.location.reload();
        } else {
          buttonUpdateExpense.disabled = false;
          buttonUpdateExpense.innerHTML = "Atualizar despesa";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageUpdateExpense").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageUpdateExpense").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiUpdateExpense");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("value_expense_update");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>